module.exports = __webpack_public_path__ + "img/teepees-map-mobile--es.1b205984.png";